import { render, staticRenderFns } from "./GradeModal.vue?vue&type=template&id=23f83780&scoped=true&"
import script from "./GradeModal.vue?vue&type=script&lang=js&"
export * from "./GradeModal.vue?vue&type=script&lang=js&"
import style0 from "./GradeModal.vue?vue&type=style&index=0&id=23f83780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f83780",
  null
  
)

export default component.exports